export const SYSTEM_INFO_ITEMS = [
  {title: '系統版本', content: '3.13'},
  {title: '最近更新', content: '2026/02/23'},
  {title: '建議瀏覽器', content: 'Google Chrome'},
  {title: '版權', content: 'Copyright © 屏東縣政府衛生局'},
  {title: '製作', content: 'Zachary @ EUCARE'},
];
